import styled from 'styled-components';
import { Button, Table, Form, Checkbox } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { Box, Flex, Text } from 'atoms';

export const PageContainer = styled(Box)`
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
`;

export const ContentWrapper = styled(Box)`
	max-width: 1400px;
	margin: 0 auto;
`;

export const PageHeader = styled(Flex)`
	margin-bottom: 24px;
	align-items: center;
	gap: 12px;
`;

export const BackButton = styled(Box)`
	cursor: pointer;
	display: flex;
	align-items: center;
	padding: 8px;
	// border-radius: 6px;
	transition: background-color 0.2s;

	&:hover {
		background-color: #f1f5f9;
	}
`;

export const PageTitle = styled(Text)`
	font-size: 24px;
	font-weight: 600;
	color: #0f172a;
	line-height: 1.2;
`;

export const PageSubtitle = styled(Text)`
	font-size: 14px;
	color: #64748b;
	margin-top: 4px;
`;

export const HeaderActions = styled(Flex)`
	margin-left: auto;
	gap: 12px;
`;

export const BulkUploadButton = styled(Button)`
	background-color: #e0f2fe;
	border: 1px solid #0ea5e9;
	color: #0369a1;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #bae6fd !important;
		border-color: #0284c7 !important;
		color: #0369a1 !important;
	}
`;

export const FormSection = styled(Box)`
	background: white;
	padding: 24px;
	// border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	margin-bottom: 20px;
`;

export const SectionTitle = styled(Text)`
	font-size: 18px;
	font-weight: 600;
	color: #0f172a;
	margin-bottom: 20px;
	display: block;
`;

export const StyledForm = styled(Form)`
	.ant-form-item-label > label {
		font-weight: 500;
		font-size: 14px;
		color: #1e293b;
		margin-bottom: 4px;
		padding-bottom: 0;
		height: 22px;
		line-height: 22px;
	}

	.ant-form-item {
		margin-bottom: 16px;
	}

	.ant-form-item-label {
		padding-bottom: 4px;
		height: 22px;
	}

	.ant-input,
	.ant-select-selector,
	.ant-picker {
		// border-radius: 6px;
		border: 1px solid #e2e8f0;
		font-size: 14px;
		height: 40px !important;
		line-height: 40px;

		&:hover {
			border-color: #94a3b8;
		}

		&:focus,
		&.ant-input-focused,
		&.ant-select-focused .ant-select-selector {
			border-color: #3b82f6;
			box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
		}
	}

	.ant-select-selector {
		height: 40px !important;
		padding: 4px 11px !important;
		display: flex !important;
		align-items: center !important;
		line-height: 40px !important;
	}

	.ant-select-selection-item {
		line-height: 40px !important;
		display: flex;
		align-items: center;
	}

	.ant-input {
		padding: 8px 12px;
		height: 40px !important;
		line-height: 22px;
	}

	.ant-picker {
		width: 100%;
		height: 40px !important;
		padding: 4px 11px !important;
		display: flex;
		align-items: center;
	}

	.ant-picker-input > input {
		height: 40px;
		line-height: 40px;
	}
`;

export const PrimaryBrowseFileButton = styled(Button)`
	height: 40px;
	padding: 0 16px;
	border: none;
	color: white;
	background-color: #1e3a8a;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;
	font-weight: 500;
	// margin-top: 26px;

	&:hover {
		background-color: #1e40af !important;
		border-color: #1e40af !important;
		color: white !important;
	}
`;

export const LightBrowseFileButton = styled(Button)`
	height: 40px;
	padding: 0 16px;
	border: none;
	color: white;
	background-color: #1e3a8a;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;
	font-weight: 500;

	&:hover:not(:disabled) {
		background-color: #1e40af !important;
		border-color: #1e40af !important;
		color: white !important;
	}

	&:disabled {
		background-color: #94a3b8;
		border-color: #94a3b8;
		color: white;
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const AddVehicleButtonWrapper = styled(Box)`
	display: flex;
	justify-content: center;
	margin-top: 16px;
	width: 100%;
`;

export const AddVehicleButton = styled(Button)`
	background-color: #1e3a8a;
	border-color: #1e3a8a;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	color: white;

	&:hover {
		background-color: #1e40af;
		border-color: #1e40af;
		color: white;
	}
`;

export const TableSection = styled(Box)`
	background: white;
	padding: 32px;
	// border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	margin-bottom: 20px;
`;

export const StyledTable = styled(Table)`
	.ant-table-thead > tr > th {
		background-color: #1e3a8a;
		color: white;
		font-weight: 500;
		border: none;
	}

	.ant-table-tbody > tr > td {
		border-bottom: 1px solid #e5e7eb;
	}
`;

export const FooterActions = styled(Flex)`
	margin-top: 24px;
	gap: 12px;
	justify-content: flex-end;
`;

export const CancelButton = styled(Button)`
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	border: 1px solid #d1d5db;
	color: #374151;
	background: white;
	// border-radius: 6px;

	&:hover {
		border-color: #9ca3af;
		color: #1f2937;
	}
`;

export const SubmitButton = styled(Button)`
	background-color: #1e3a8a;
	border-color: #1e3a8a;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	color: white;
	// border-radius: 6px;

	&:hover {
		background-color: #1e40af;
		border-color: #1e40af;
		color: white;
	}
`;

export const HiddenFileInput = styled.input`
	display: none !important;
	visibility: hidden !important;
	position: absolute !important;
	width: 0 !important;
	height: 0 !important;
	opacity: 0 !important;
	pointer-events: none !important;
`;

export const FileDisplayContainer = styled(Flex)`
	margin-top: 8px;
	padding: 8px 12px;
	background-color: #f9fafb;
	border: 1px solid #e2e8f0;
	// border-radius: 6px;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`;

export const FileInfo = styled(Flex)`
	align-items: center;
	gap: 8px;
	flex: 1;
	min-width: 0;
`;

export const FileIcon = styled(FileTextOutlined)`
	font-size: 18px;
	color: #dc2626;
	flex-shrink: 0;
`;

export const PendingDocumentStatus = styled(Flex)`
	align-items: center;
	gap: 6px;
	color: #f59e0b;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
`;

export const RemoveFileButton = styled(Box)`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	// border-radius: 4px;
	color: #64748b;
	transition: all 0.2s;
	flex-shrink: 0;

	&:hover {
		background-color: #e2e8f0;
		color: #dc2626;
	}
`;

export const FormGrid = styled(Box)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 24px;
	row-gap: 16px;
`;

export const UploadBlock = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-height: 40px;
`;

export const InlineRow = styled(Box)`
	display: flex;
	align-items: flex-start;
	gap: 30px; // Increased gap between browse button and date picker
	width: 100%;
`;

export const UploadButtonWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 6px;
	flex-shrink: 0;
`;

export const DatePickerWrapper = styled(Box)`
	flex: 1;
	min-width: 0;
	margin-top: -22px; // Pull up to align date picker with browse button

	.ant-form-item {
		margin-bottom: 0;
	}
`;

export const SkipDocumentUploadRow = styled(Flex)`
	background-color: #f1f5f9;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	padding: 12px 16px;
	align-items: center;
	justify-content: space-between;
	height: 40px;
`;

export const SkipDocumentCheckbox = styled(Checkbox)`
	.ant-checkbox-inner {
		width: 18px;
		height: 18px;
		border-radius: 4px;
		border-color: #94a3b8;
	}

	.ant-checkbox-checked .ant-checkbox-inner {
		background-color: #1e3a8a;
		border-color: #1e3a8a;
	}

	span:last-child {
		font-size: 14px;
		font-weight: 500;
		color: #1e293b;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}
`;

export const SkipDocumentInfoIcon = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	border: 2px solid #0d9488;
	color: #0d9488;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		background-color: #0d9488;
		color: white;
	}
`;
